export default __webpack_public_path__ + "static/media/walnut.side.texture.bc58b948.webp";